import { Component, ViewChildren, QueryList, OnInit,ViewChild,OnDestroy,NgZone, } from "@angular/core";
import {
  Platform,
  IonRouterOutlet,
  AlertController,
  ModalController,
  ToastController,
  NavController,
  AnimationController,
  IonContent
} from "@ionic/angular";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { Network } from "@awesome-cordova-plugins/network/ngx";
import { TranslateService } from "@ngx-translate/core";
import { pageTransition } from './animations/customAnimation';

import { Router } from "@angular/router";
import { Events } from "./provider/events.service";
import { AuthService } from "./services/auth.service";
import { ApiService } from "./provider/api.service";
import { ConfigService } from "./provider/config.service";
import { endpoints } from "./constant/endpoints";
import { register } from "swiper/element/bundle";
import { Subject, debounceTime, filter, first, fromEvent, takeUntil } from 'rxjs';
register();
import * as moment from "moment";
import { DataService } from "./services/data.service";
import { Keyboard, KeyboardResize, KeyboardInfo } from "@capacitor/keyboard";

type ActiveInputElement = HTMLInputElement | HTMLTextAreaElement | HTMLElement; // HTMLElement to cover ion-input root


export interface HSLColor {
  h: number;
  s: number;
  l: number;
  opacity?: number;
}

export interface HSLAdjustment {
  fixed?: number;
  percent?: number;
  adjust?: number;
  h?: number;
  s?: number;
  l?: number;
}

export interface HSLModifyOptions {
  h?: HSLAdjustment;
  s?: HSLAdjustment;
  l?: HSLAdjustment;
  opacity?: number;
}

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"]
})

export class AppComponent implements OnInit {
  @ViewChildren(IonRouterOutlet)
  routerOutlets: QueryList<IonRouterOutlet>;
  APP_VERSION = "1.0.0";
  settings: any = {};
  backButton = true;
  connectedToInternet: boolean = true;
  splash = false;
  shadowConfigs = {
    // Core shadows - More punchy and defined
    'm': [
        { x: 0, y: 1, blur: 2, opacity: 0.12 },
        { x: 1, y: 3, blur: 6, spread: -1, opacity: 0.15 },
        { x: 1, y: 6, blur: 12, spread: -2, opacity: 0.12 }
    ],
    'l': [
        { x: 0, y: 1, blur: 2, opacity: 0.10 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.12 }
    ],
    'h': [
        { x: 0, y: 3, blur: 6, spread: -1, opacity: 0.15 },
        { x: 1, y: 6, blur: 12, spread: -2, opacity: 0.20 },
        { x: 1, y: 12, blur: 24, spread: -3, opacity: 0.20 }
    ],
    'h2': [ // Dramatic high shadow
        { x: 0, y: 4, blur: 8, spread: -1, opacity: 0.18 },
        { x: 1, y: 8, blur: 16, spread: -2, opacity: 0.15 },
        { x: 1, y: 16, blur: 32, spread: -4, opacity: 0.12 }
    ],

    // Elevation shadows - Crisper and more defined
    'elevation-low': [
        { x: 0, y: 1, blur: 2, opacity: 0.15 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.12 }
    ],
    'elevation-medium': [
        { x: 0, y: 2, blur: 4, opacity: 0.15 },
        { x: 1, y: 4, blur: 8, spread: -1, opacity: 0.18 },
        { x: 1, y: 8, blur: 16, spread: -2, opacity: 0.15 }
    ],
    'elevation-high': [
        { x: 0, y: 4, blur: 8, spread: -1, opacity: 0.20 },
        { x: 1, y: 8, blur: 16, spread: -2, opacity: 0.22 },
        { x: 1, y: 16, blur: 32, spread: -4, opacity: 0.18 }
    ],

    // Diffuse shadows - More noticeable ambient effect
    'diffuse': [
        { x: 0, y: 0, blur: 4, spread: 0, opacity: 0.08 },
        { x: 1, y: 2, blur: 8, spread: -1, opacity: 0.10 },
        { x: 1, y: 4, blur: 16, spread: -2, opacity: 0.12 }
    ],
    'color-s': [ // Enhanced colored special diffuse
        { x: 0, y: 0, blur: 8, spread: 2, opacity: 0.08 },
        { x: 1, y: 4, blur: 16, spread: -1, opacity: 0.12 },
        { x: 1, y: 8, blur: 24, spread: -2, opacity: 0.15 }
    ],

    // Inner shadows - Stronger depth effect
    'l1': [
        { x: 0, y: 1, blur: 2, opacity: 0.15, inset: true },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.20, inset: true }
    ],
    'l2': [
        { x: 0, y: 2, blur: 4, opacity: 0.20, inset: true },
        { x: 1, y: 4, blur: 8, spread: 1, opacity: 0.25, inset: true }
    ],
    'l3': [
        { x: 0, y: 1, blur: 12, spread: 1, opacity: 0.05, inset: true },
        { x: 1, y: 2, blur: 20, spread: -4, opacity: 0.10, inset: true }
    ],
    'inner': [
        { x: 1, y: -1, blur: 2,spread: 2, opacity: 0.1, inset: true },
        { x: 1, y: 1, blur: 4, spread: 1, opacity: 0.2, inset: true }
    ],
    'inner2': [
        { x: 0, y: 0, blur: 1,spread: 1, opacity: 0.1, inset: true },
        { x: 0, y: 0, blur: 0, spread: 1, opacity: 0.3, inset: true }
    ],    
        'inner3': [
        { x: 0, y: 0, blur: 1,spread: 0, opacity: 0.1, inset: true },
        { x: 0, y: 0, blur: 0, spread: 0, opacity: 0.1, inset: true }
    ],   
    'l4': [
        { x: 0, y: 4, blur: 8, opacity: 0.25, inset: true },
        { x: 1, y: 8, blur: 16, spread: 2, opacity: 0.30, inset: true }
    ],

    // Card shadows - Sharper and more defined
    'card': [
        { x: 0, y: 1, blur: 2, spread: 0, opacity: 0.12 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.15 },
        { x: 1, y: 4, blur: 8, spread: -2, opacity: 0.12 }
    ],
    'm-c': [ // Colored medium with better contrast
        { x: 0, y: 2, blur: 4, spread: -1, opacity: 0.15 },
        { x: 1, y: 4, blur: 8, spread: -2, opacity: 0.18 },
        { x: 1, y: 8, blur: 16, spread: -3, opacity: 0.15 }
    ],

    // Directional shadows - More pronounced
    'side': [
        { x: 1, y: 1, blur: 4, spread: -1, opacity: 0.12 },
        { x: 1.5, y: 1.5, blur: 8, spread: -2, opacity: 0.15 }
    ],
    'm-side': [
        { x: 3, y: 5, blur: 10, spread: -1, opacity: 0.05 },
        { x: 5, y: 3, blur: 10, spread: -2, opacity: 0.1 }
    ],
    'side-anim': [
        { x: 3, y: 5, blur: 10, spread: -1, opacity: 0.05 },
        { x: 5, y: 3, blur: 10, spread: -2, opacity: 0.1 }
    ],
    'side-anim-end': [
        { x: 9, y: 15, blur: 10, spread: -1, opacity: 0.15 },
        { x: 18, y: 30, blur: 10, spread: -2, opacity: 0.1 }
    ],
    'btn-anim': [
        { x: 1.5, y: 2.5, blur: 7, spread: -0.5, opacity: 0.05 },
        { x: 2.5, y: 1.5, blur: 7, spread: -1, opacity: 0.1 }
    ],
    'btn-anim-end': [
        { x: 4.5, y: 7.5, blur: 6, spread: -0.5, opacity: 0.2 },
        { x: 9, y: 15, blur: 6, spread: -1, opacity: 0.1 }
    ],
    'option-anim': [
        { x: 1, y: 2, blur: 5, spread: -0.5, opacity: 0.05 },
        { x: 2, y: 1, blur: 5, spread: -1, opacity: 0.1 }
    ],
    'option-anim-end': [
        { x: 3, y: 2, blur: 6, spread: -0.5, opacity: 0.2 },
        { x: 9, y: 1, blur: 6, spread: -1, opacity: 0.1 }
    ],
    // 'side-anim': [
    //     { x: 0, y: -0.5, blur: 0, spread: 0, opacity: 0.1 },
    //     { x: 0.5, y: 0, blur: 0, spread: 0, opacity: 0.2 }
    // ],
    // 'side-anim-end': [
    //     { x: -0.5, y: 0, blur: 0, spread: 0, opacity: 0.1 },
    //     { x: 0, y: 0.5, blur: 0, spread: 0, opacity: 0.2 }
    // ],

    // Special effects - Enhanced visibility
    'm-anim': [ // Animation-friendly with better presence
        { x: 0, y: 2, blur: 4, spread: -1, opacity: 0.12 },
        { x: 1, y: 4, blur: 8, spread: -2, opacity: 0.15 },
        { x: 1, y: 8, blur: 16, spread: -3, opacity: 0.12 }
    ],
    'm-small': [ // Subtle but visible
        { x: 0, y: 1, blur: 2, opacity: 0.10 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.12 },
        { x: 1, y: 3, blur: 6, spread: -1, opacity: 0.10 }
    ],
    'md': [ // Dense medium with better definition
        { x: 0, y: 1, blur: 2, opacity: 0.15 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.20 }
    ],
    'mid': [ // Dense medium with better definition
        { x: 0, y: 1, blur: 2, opacity: 0.15 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.20 }
    ]
};
  today = moment().format("YYYY-MM-DD");
  colorprimary: any;
  colorsecondary: any;
  colortertiary: any;
  p2: any;
  s2: any;
  t2: any;
  p3: any;
  s3: any;
  t3: any;
  p4: any;
  s4: any;
  t4: any;
  shadowlight: any;
  shadowdark: any;
  shadowcolorlight: any;
  shadowcolordark: any;
  bglight: any;
  bgdark: any;
  highlight: any;
  highdark: any;
  diffuselight: any;
  diffusedark: any;
  diffuselightselected: any;
  diffusedarkselected: any;
  colorlight: any;
  colordark: any;
  colorback: any;
  colorbackdark: any;
  greenmacro: any;
  redmacro: any;
  yellowmacro: any;
  shadowhighlight: any;
  shadowhighdark: any;
  lowNutrition: any;
  highNutrition: any;
  avgNutrition: any;
  carbcolor: any;
  caloriecolor: any;
  protcolor: any;
  fatcolor: any;

  protcolorlight: string;
  fatcolorlight: string;
  carbcolorlight: string;
  caloriecolorlight: string;
  weekMenuData: any[];
  customer: any;
  daysafter: number;
  slideback: string;
  colortertiarymain: string;
  colorsecondarymain: string;
  colorprimarymain: string;
  // colors = {
  //     primary_container: '#d2a787',
  //     secondary_container: '#DFA878',
  //     tertiary_container: '#6C3428',
  //     on_primary_container: '#d2a787',
  //     on_secondary_container: '#DFA878',
  //     on_tertiary_container: '#6C3428'
  // };
  colors = {
    primary: "#35858b",
    secondary: "#4fbdba",
    tertiary: "#082227",
    on_primary: "#35858b",
    on_secondary: "#4fbdba",
    on_tertiary: "#082227",
  };
  darkermain = {
    h: 0, // Hue in degrees (0 to 360)
    s: 5, // Saturation in percentage (0 to 100)
    l: 5, // Lightness in percentage (0 to 100)
  };
  lightermain = {
    h: 0, // Hue in degrees (0 to 360)
    s: 0, // Saturation in percentage (0 to 100)
    l: 95, // Lightness in percentage (0 to 100)
  };
  white: string;
  black: string;
  light: any;
  dark: any;
  lightgrey: string;
  darkgrey: string;
  darker: string;
  grey: string;
  greyhalf: string;
  greymore: string;
  greyless: string;
  darklightgrey: string;
  darkdarkgrey: string;
  darkdarker: string;
  darkgreyhalf: string;
  darkgreymore: string;
  darkgreyless: string;
  banners: string[] = []; // Store multiple banners
  currentBannerIndex = 0; // To track the current banner index
  bannerSwitchInterval: any;
  invertPrime: string;
  invertSecond: string;
  invertTri: string;
  dtextprimary: string;
  dtextsecond: string;
  dtexttri: string;

  serverVersion: any = 0;
  splittedVersion: any;
  androidURL = "https://play.google.com/store/apps/details?id=com.dietmaster1";
  iosURL = "https://apps.apple.com/us/app/dietmaster/id1600484121";
  appPayload: any;
  days: any;
  diffusecolorselected: string;
  diffusecolor: string;
  colorprimarylighter: string;
  colorsecondarylighter: string;
  colortertiarylighter: string;
  colorprimarydeeper: string;
  colorsecondarydeeper: string;
  colortertiarydeeper: string;
   backButtonSubscription: any;
   lastTimeBackPress = 0;
   timePeriodToExit = 2000;
  fixtest: {
    h: any; s: any; // Ensure saturation is between 3-100%
    l: any; // Ensure lightness is between 3-100%
  };
  q1: any;
  q2: any;
  q3: any;
  q4: any;
destroy$ = new Subject<void>();
   activeInput: ActiveInputElement | null = null; // Use the new union type
    @ViewChild(IonContent, { static: false }) content!: IonContent;
  constructor(
    private router: Router,
    private platform: Platform,
    private events: Events,
    private network: Network,
    private inAppBrowser: InAppBrowser,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private screenOrientation: ScreenOrientation,
    private authService: AuthService,
    private configService: ConfigService,
    private apiService: ApiService,
    private zone: NgZone 
  ) {
    this.configService.getAppSettings().then((settingData: any) => {
      this.settings = JSON.parse(settingData);  
      console.log(this.settings, "settings") 
      if (this.settings.appLanguage){
      this.translate.setDefaultLang(this.settings?.appLanguage);
      this.translate.use(this.settings.appLanguage);
      }
      this.appUser(this.settings.currentUser);
      if (this.platform.is("capacitor")) {
        this.screenOrientation.lock(
          this.screenOrientation.ORIENTATIONS.PORTRAIT,
        );
        this.checkNetworkConnection();
      }
      
    });
    this.initializeBackButton();
  }
  async ngOnInit() {
    await this.loadBackgroundData();
      // Keyboard.setResizeMode({ mode: KeyboardResize.None });
      // // Listen for keyboard show event
      // Keyboard.addListener('keyboardWillShow', (info: KeyboardInfo) => {
      //   this.zone.run(() => {
      //     console.log('Keyboard will show. Height:', info.keyboardHeight);
      //     // Small delay to ensure all DOM elements are rendered after keyboard appears
      //     setTimeout(() => {
      //       this.adjustContentForKeyboard(info.keyboardHeight);
      //     }, 50); // Adjust delay if needed
      //   });
      // })
      // .catch(err => console.error('Error adding keyboardWillShow listener:', err));

      // Keyboard.addListener('keyboardWillHide', () => {
      //   this.zone.run(() => {
      //     console.log('Keyboard will hide.');
      //     this.resetContentAfterKeyboard();
      //   });
      // })
      // .catch(err => console.error('Error adding keyboardWillHide listener:', err));

      // fromEvent(document, 'focusin')
      //   .pipe(
      //     debounceTime(50),
      //     takeUntil(this.destroy$)
      //   )
      //   .subscribe((event: Event) => {
      //     const target = event.target as HTMLElement;
      //       this.activeInput = target;
      //     console.log('Active input set:', this.activeInput.id || this.activeInput.tagName);
      //   });
  }
  async loadBackgroundData() {

    this.apiService.get(endpoints.configuration).subscribe(async (response) => {
      if (response.success) {
        console.log(response, "config")
        this.daysafter = response?.settings?.menu_selection_before
          ? Number(response?.settings?.menu_selection_before)
          : 0;
        const htmlEl = document.querySelector('html');
     
        this.colors.primary =
          response.data.organization.configurations.theme.primary;
        this.colors.secondary =
          response.data.organization.configurations.theme.secondary;
        this.colors.tertiary =
          response.data.organization.configurations.theme.tertiary;
        this.colors.on_primary =
          response.data.organization.configurations.theme.on_primary;
        this.colors.on_secondary =
          response.data.organization.configurations.theme.on_secondary;
        this.colors.on_tertiary =
          response.data.organization.configurations.theme.on_tertiary;
          this.lowNutrition = this.finalHSL(
            this.hexToHsl(response.data.organization.configurations.settings.low_nutrition_highlight )
          );
          this.avgNutrition = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.settings
                .average_nutrition_highlight
            )
          );
          this.highNutrition = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.settings
                .high_nutrition_highlight
            )
          );
  
          this.caloriecolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_primary_container
            )
          );
          this.protcolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_secondary_container
            )
          );
          this.carbcolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_tertiary_container
            )
          );
          this.fatcolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_error_container
            )
          );
  
          this.caloriecolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_primary_container
            )
          );
          this.protcolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_secondary_container
            )
          );
          this.carbcolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_tertiary_container
            )
          );
          this.fatcolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_error_container
            )
          );
  
      this.p2 = this.finalHSL(this.hexToHsl(response.data.organization.configurations.theme.primary));
      this.s2 = this.finalHSL(this.hexToHsl(response.data.organization.configurations.theme.secondary));
      this.t2 = this.finalHSL(this.hexToHsl(response.data.organization.configurations.theme.tertiary));

       htmlEl.style.setProperty("--kcal", this.caloriecolor);
       htmlEl.style.setProperty("--prot", this.protcolor);
       htmlEl.style.setProperty("--carb", this.carbcolor);
       htmlEl.style.setProperty("--fat", this.fatcolor);

       htmlEl.style.setProperty("--kcal-light", this.caloriecolorlight);
       htmlEl.style.setProperty("--prot-light", this.protcolorlight);
       htmlEl.style.setProperty("--carb-light", this.carbcolorlight);
       htmlEl.style.setProperty("--fat-light", this.fatcolorlight);

       htmlEl.style.setProperty("--p2", this.p2);
       htmlEl.style.setProperty("--s2", this.s2);
       htmlEl.style.setProperty("--t2", this.t2);

       htmlEl.style.setProperty("--low-nutri", this.lowNutrition);
       htmlEl.style.setProperty("--avg-nutri", this.avgNutrition);
       htmlEl.style.setProperty("--high-nutri", this.highNutrition);

      //   //color-main
       this.theColorUpdate(response.data.organization.configurations.theme.primary,response.data.organization.configurations.theme.secondary,response.data.organization.configurations.theme.tertiary);
      
       //color-2
      // this.theColorUpdate(response.data.organization.configurations.theme.on_primary,response.data.organization.configurations.theme.on_secondary,response.data.organization.configurations.theme.on_tertiary);

      //   //color-3
      //  this.theColorUpdate(response.data.organization.configurations.theme.primary_container,response.data.organization.configurations.theme.secondary_container,response.data.organization.configurations.theme.tertiary_container);

          
          
        this.configService.setStorage('appPayload', response.data.organization);
        this.appPayload = await this.configService.getStorage('appPayload');
        this.events.publish('payload:configuration', {
          appPayload: response.data.organization,
          time: new Date(),
        });
        if (this.appPayload.show_menu_items == "No") {
                  this.settings.testEnabled = true
        } else {
                  this.settings.testEnabled = false
        }
        const isDarkMode = this.settings.appDarkMode;
       await this.configService.setStorage('appSettings', this.settings);
        console.log(this.settings);
      }
    });
   

    this.events.subscribe("language:change", (data: any) => {
      console.log(data);
      setTimeout(() => {
        // window.location.reload();
      }, 200);
    });
    this.events.subscribe("DarkMode:change", (data: any) => {
      console.log(data);
    });
    this.events.subscribe("user:login", (data: any) => {
      console.log(data.user);
      if (data.user == null) {
        this.configService.getAppSettings().then(async (settingData: any) => {
          this.settings = JSON.parse(settingData);
          console.log(this.settings);
          this.settings.currentUser = null;
          this.configService.setStorage("appSettings", this.settings);

          try {
            const element = await this.modalCtrl.getTop();
            if (element) {
              element.dismiss();
              return;
            }
          } catch (error) {
            console.log(error);
          }
          this.authService.setAuthUser(null);
          this.authService.logOutUser();
          this.navCtrl.navigateRoot(["/onboarding"]);
        });
      }
      {
      }
    });
    this.events.subscribe('app:update', (data: any) => {
    	const customer = this.authService.getAuthUser();
    	console.log(customer);
    	if (data.user == null) {
    		this.configService.getAppSettings()
    			.then(async (settingData: any) => {
    				this.settings = JSON.parse(settingData);
    				console.log(this.settings);
    				this.settings.currentUser = null;
    				this.configService.setStorage('appSettings', this.settings);
    				this.authService.setAuthUser(null);
    				this.authService.logOutUser();
    				this.navCtrl.navigateRoot(['/onboarding']);
    			}
    			);
    	}
    });
  }
  appUser = async (currentUser: any) => {
    console.log(currentUser);

    if (!(
      currentUser &&
      currentUser != null &&
      window.localStorage.getItem("auth-token") != "null" &&
      window.localStorage.getItem("auth-token") != null
    )) {
      window.localStorage.setItem("auth-token", null);
    } 
  };
  ngOnDestroy() {
    if (this.backButtonSubscription) {
      this.backButtonSubscription.unsubscribe();
    }
  }
  //   onInputFocus(event: any) {
  //   this.activeInput = event.target;
  // }
  //   async adjustContentForKeyboard(keyboardHeight: number) {
  //   if (!this.activeInput || !this.content) {
  //     console.warn('No active input or IonContent reference available for keyboard adjustment.');
  //     return;
  //   }

  //   // Use the activeInput for getBoundingClientRect()
  //   // This will work for both native inputs and the host element of ion-input/ion-textarea
  //   const inputRect = this.activeInput.getBoundingClientRect();
  //   const contentScrollElement = await this.content.getScrollElement();
  //   const currentScrollTop = contentScrollElement.scrollTop;

  //   console.log('--- Keyboard Adjustment Debugging ---');
  //   console.log('Keyboard Height:', keyboardHeight);
  //   console.log('Active Input TagName:', this.activeInput.tagName);
  //   console.log('Input Rect (top, bottom, height):', inputRect.top, inputRect.bottom, inputRect.height);
  //   console.log('Content Scroll Element Current ScrollTop:', currentScrollTop);
  //   console.log('Window Inner Height:', window.innerHeight);

  //   // The bottom of the viewport that's visible (i.e., the top edge of the keyboard)
  //   const keyboardTopInViewport = window.innerHeight - keyboardHeight;

  //   // Calculate if the input's bottom is below the keyboard's top edge in the viewport
  //   const isInputHidden = inputRect.bottom > keyboardTopInViewport;

  //   if (isInputHidden) {
  //     const scrollAmount = inputRect.bottom - keyboardTopInViewport + 20; // +20 for extra padding
  //     const newScrollPosition = currentScrollTop + scrollAmount;

  //     console.log('Keyboard Top In Viewport:', keyboardTopInViewport);
  //     console.log('Input is hidden. Scroll Amount Needed:', scrollAmount);
  //     console.log('Calculated New Scroll Position:', newScrollPosition);

  //     await this.content.scrollToPoint(0, newScrollPosition, 300);
  //     console.log(`Scrolled to show input. New scrollY: ${newScrollPosition}`);
  //   } else {
  //     console.log('Input not hidden by keyboard, no scroll needed.');
  //   }
  //   console.log('--- End Debugging ---');
  // }
  //  async resetContentAfterKeyboard() {
  //   this.activeInput = null;
  //   console.log('Content reset after keyboard hide.');
  // }

  checkLatestVersion = async (appData: any) => {
    const versionNumbner = this.APP_VERSION; //await this.appVersion.getVersionNumber();
    if (this.platform.is("android")) {
      const androidResponse = appData.android;
      this.androidURL = androidResponse.application_url;
      this.serverVersion = androidResponse.latest_version.split(".");
      this.splittedVersion = versionNumbner.split(".");
      //alert(this.serverVersion[0] +' - '+ this.splittedVersion[0] + ' - '+androidResponse.enabled);
      if (androidResponse.enabled) {
        this.backButton = false;
        this.appUpdate(appData.alerts.title, appData.alerts.description);
      } else if (this.serverVersion[0] > this.splittedVersion[0]) {
        //major changes
        this.backButton = false;
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
        );
        this.events.publish("app:update", { user: null, time: new Date() });
      } else if (this.serverVersion[1] > this.splittedVersion[1]) {
        //minor changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.minor.description,
          appData.alerts.button_text,
          true,
        );
      } else if (this.serverVersion[2] > this.splittedVersion[2]) {
        //optional changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true,
        );
      }
    } else if (this.platform.is("ios")) {
      const iosResponse = appData.ios;
      //alert(versionNumbner);
      //alert(iosResponse.latest_version);
      this.iosURL = iosResponse.url;
      this.serverVersion = iosResponse.latest_version.split(".");
      this.splittedVersion = versionNumbner.split(".");
      if (iosResponse.enabled) {
        this.backButton = false;
        this.appUpdate(appData.alerts.title, appData.alerts.description);
      } else if (this.serverVersion[0] > this.splittedVersion[0]) {
        //major changes
        this.backButton = false;
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
        );
        this.events.publish("app:update", { user: null, time: new Date() });
      } else if (this.serverVersion[1] > this.splittedVersion[1]) {
        //minor changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true,
        );
      } else if (this.serverVersion[2] > this.splittedVersion[2]) {
        //optional changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true,
        );
      }
    }
  };
  openAppstoreEntry = async () => {
    if (this.platform.is("android")) {
      this.inAppBrowser.create(this.androidURL, "_blank");
      // NativeMarket.openStoreListing({
      //     appId: await this.appVersion.getPackageName().then(packageName => {return packageName;})
      // });
    } else if (this.platform.is("ios")) {
      this.inAppBrowser.create(this.iosURL, "_blank");
    }
  };
  appUpdate = async (header, message, buttonText = "", allowcloss = false) => {
    const buttons = [];
    if (buttonText != "") {
      buttons.push({
        text: buttonText,
        handler: () => {
          this.openAppstoreEntry();
        },
      });
    }
    if (allowcloss) {
      buttons.push({
        text: "Close",
        role: "Cancel",
      });
    }
    await this.alertCtrl
      .create({
        header,
        message,
        buttons,
        mode: "ios",
        backdropDismiss: allowcloss,
      })
      .then((alertElem) => alertElem.present());
  };
 hexToHsl(hex) {
    hex = hex.replace(/^#/, '');

    let r = 0,
        g = 0,
        b = 0;

    // Check for shorthand hex (e.g., #abc) and expand it
    if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
        // Full hex (e.g., #aabbcc)
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
    } else {
        throw new Error('Invalid HEX color format');
    }

    // Convert RGB values to a range of 0 to 1
    r /= 255;
    g /= 255;
    b /= 255;

    // Find the max and min values of RGB
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    // Calculate Lightness
    let l = (max + min) / 2;

    let h = 0,
        s = 0;

    if (delta !== 0) {
        // Calculate Hue and Saturation only if there's no gray (delta = 0)
        // Saturation
        s = delta / (1 - Math.abs(2 * l - 1));

        // Hue
        if (max === r) {
            h = ((g - b) / delta + (g < b ? 6 : 0)) % 6;
        } else if (max === g) {
            h = (b - r) / delta + 2;
        } else if (max === b) {
            h = (r - g) / delta + 4;
        }

        h *= 60; // Convert to degrees
    }

    // Convert to percentages
    h = Math.round(h);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return {
        h,
        s,
        l
    };
}
 invertHsl(hsl) {
    let h = (hsl.h + 180) % 360;
    let l = hsl.l < 50 ? hsl.l + 30 : hsl.l - 30;
    return {
        h: h,
        s: hsl.s,
        l: l,
        alpha: 1
    };
}

 dynamicText(hsl) {
    let l = hsl.l <= 51 ? 100 : 0;
    console.log(l, hsl.l, 'l and hsl.l');
    const safeHSL = {
        h: 0,
        s: 0,
        l: l,
        alpha: hsl?.alpha ?? 1 // Use hsl.alpha if defined, otherwise default to 1
    };
    return safeHSL;
}

 setColorVariables(htmlEl, prefix, baseHSL, shades) {
    Object.keys(shades).forEach((shade) => {
        // Get the modified HSL values
        const modifiedHSL = shades[shade]({
            ...baseHSL
        });

        // Set the traditional variable with opacity included
        htmlEl.style.setProperty(
            `--ion-${shade}-${prefix}`,
            this.finalHSL(modifiedHSL)
        );

        // Set a new color-only variable without opacity
        htmlEl.style.setProperty(
            `--drop-${shade}-${prefix}`,
            `${modifiedHSL.h}deg ${modifiedHSL.s}% ${modifiedHSL.l}%`
        );
    });
}

 generateShadowString(shadowConfig, hsl) {
    return shadowConfig.map(shadow => {
        let spreadStr = shadow.spread ? ` ${shadow.spread}px` : '';
        let insetStr = shadow.inset ? ' inset' : '';
        return `${shadow.x}px ${shadow.y}px ${shadow.blur}px${spreadStr} hsl(${hsl.h}deg ${hsl.s}% ${hsl.l}% / ${shadow.opacity})${insetStr}`;
    }).join(', ');
}

 setShadowVariables(htmlEl, prefix, baseHSL) {
    // Create light and dark versions of the base color for shadows
    let shadowLight = this.hslModify(baseHSL, {
        l: {
            fixed: 25
        },
        s: {
            percent: -10
        }
    });

    let shadowDark = this.hslModify(baseHSL, {
        l: {
            fixed: 10
        },
        s: {
            percent: 60
        }
    });

    let shadowColor = this.hslModify(baseHSL, {
        opacity: 1
    });
    let shadowColor2 = this.hslModify(baseHSL, {
        opacity: 0.5
    });
    let shadowMain = this.hslModify(baseHSL, {
        l: {
            fixed: 5
        },
        s: {
            fixed: 0
        }
    });
        let shadowGrey = this.hslModify(baseHSL, {
          l: {l: Math.min(Math.max(baseHSL.l * 0.50, 10),40)},
          s: {s: Math.min(Math.max(baseHSL.s * .60, 40), 100)},
          h: {h: baseHSL.h < 180 ? (baseHSL.h + 60) % 360 : (baseHSL.h - 60 + 360) % 360},
          opacity: 1
    });

    // Set base shadow variables
    htmlEl.style.setProperty(`--shadow-light`, `${shadowLight.h}deg ${shadowLight.s}% ${shadowLight.l}%`);
    htmlEl.style.setProperty(`--shadow-dark`, `${shadowDark.h}deg ${shadowDark.s}% ${shadowDark.l}%`);

    // Generate all shadow variations
    Object.entries(this.shadowConfigs).forEach(([key, config]) => {
        htmlEl.style.setProperty(
            `--shadow-${key}`,
            this.generateShadowString(config, shadowMain)
        );

        // Also create a dark version
        htmlEl.style.setProperty(
            `--shadow-${key}-dark`,
            this.generateShadowString(config, shadowDark)
        );
               htmlEl.style.setProperty(
            `--shadow-${key}-grey`,
            this.generateShadowString(config, shadowGrey)
        );
        htmlEl.style.setProperty(
            `--shadow-${key}-light`,
            this.generateShadowString(config, shadowLight)
        );
        htmlEl.style.setProperty(
            `--shadow-${key}-color`,
            this.generateShadowString(config, shadowColor)
        );
    });
}

 theColorUpdate(primary, secondary, tertiary) {
    const htmlEl = document.documentElement; // Get the root HTML element
    if (!htmlEl) return;

    const primaryHSL = this.hexToHsl(primary);
    const secondaryHSL = this.hexToHsl(secondary);
    const tertiaryHSL = this.hexToHsl(tertiary);
    const greyHSL = this.hexToHsl('#c1c1c1');
    const dangerHSL = this.hexToHsl('#d32f2f');      // Soft red (danger)
    const successHSL = this.hexToHsl('#388e3c');     // Balanced green (success)
    const warningHSL = this.hexToHsl('#f57c00');     // Slightly muted orange (warning)
    const infoHSL = this.hexToHsl('#1976d2');        // Standard info blue
    const maleHSL = this.hexToHsl('#1565c0');        // Deep, bold blue
    const femaleHSL = this.hexToHsl('#8e24aa');      // Elegant purple
    const healthHSL = this.hexToHsl('#2e7d32');      // Strong green (wellness)
    const unhealthHSL = this.hexToHsl('#c62828');    // Deep red (opposite to health)
    let shades = {
      
        color: (hsl) => this.hslModify(hsl, {opacity: 1
          }),

        black: (hsl) => this.hslModify(hsl, {
          l: {fixed: 2},
          opacity: 1
          }),
        white: (hsl) => this.hslModify(hsl, {
          l: {fixed: 100},
          opacity: 1
          }),

        pass: (hsl) => this.hslModify(hsl, {
          opacity: 0.05
          }),
        ultra: (hsl) => this.hslModify(hsl, {
          opacity: 0.15
          }),
        fade: (hsl) => this.hslModify(hsl, {
          opacity: 0.25
          }),
        less: (hsl) => this.hslModify(hsl, {
          opacity: 0.35
          }),
        clear: (hsl) => this.hslModify(hsl, {
          opacity: 0.5
          }),
        half: (hsl) => this.hslModify(hsl, {
          opacity: 0.75
          }),
        more: (hsl) => this.hslModify(hsl, {
          opacity: 0.85
          }),

        shadeLight: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.l * 1.10, 10),90)},
          s: {s: Math.min(Math.max(hsl.s * 0.90, 10), 100)},
          opacity: 1
          }),

        shadeDark: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.l * 0.90, 10),90)},
          s: {s: Math.min(Math.max(hsl.s * 1.10, 10), 100)},
          opacity: 1
          }),        
          
        light: (hsl) => this.hslModify(hsl, {
          l: {s: Math.min(Math.max(hsl.l * 2.30, 10), 70)},
          s: {s: Math.min(Math.max(hsl.s * 0.30, 10), 100)},
          opacity: 1
          }),

        dark: (hsl) => this.hslModify(hsl, {
          l: {s: Math.min(Math.max(hsl.l * 0.30, 10), 30)},
          s: {s: Math.min(Math.max(hsl.s * 1.30, 10), 100)},
          opacity: 1
          }),
          
        lighter: (hsl) => this.hslModify(hsl, {
          l: {s: Math.min(Math.max(hsl.l * 2.30, 10), 80)},
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 100)},
          opacity: 1
          }),

        darker: (hsl) => this.hslModify(hsl, {
          l: { l: 5 },
          s: {s: Math.min(Math.max(hsl.s * 1.50, 10), 100)},
          opacity: 1
          }),

        bright: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.s * 1.60, 10), 90)},
          s: {s: Math.min(Math.max(hsl.s * 1.20, 10), 90)},
          opacity: 1
        }),
        washed: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 50)},
          l: {l: 92},
          opacity: 1
        }),
        bareLight: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 70)},
          l: {l: 90},
          opacity: 1
        }),
        bareDark: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 70)},
          l: {l: 10},
          opacity: 1
        }),
        highlight: (hsl) => this.hslModify(hsl, {
          l: {l: hsl.l > 60 ? Math.min(Math.max(hsl.l - 10, 20), 80) : Math.min(Math.max(hsl.l + 15, 10), 90)},
          h: {h: (hsl.h + 5) % 360},
          s: {s: Math.min(Math.max(hsl.s * 1.25, 10), 90)},
          opacity: 1
        }),
        dull: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.s * 1, 10), 45)},
          s: {s: Math.min(Math.max(hsl.s * 0.95, 30), 80)},
          opacity: 1
        }),
        cool: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(hsl.s - 10, 70)},
          h: {h: (hsl.h + 15) % 360},
          opacity: 1
        }),
        warm: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(hsl.s + 10, 70)},
          h: {h: (hsl.h - 15 + 360) % 360},
           opacity: 1
        }),
        diffuseLight: (hsl) => this.hslModify(hsl, {
          l: {l: 95},
          s: {s: Math.min(Math.max(hsl.s * 0.75, 30), 80)},
          opacity: 0.9
        }),
        diffuseDark: (hsl) => this.hslModify(hsl, {
          l: {l: 3},
          opacity: 0.7
        }),
      

        text: (hsl) => this.dynamicText(hsl),
        invert: (hsl) => this.invertHsl(hsl),
    }

    this.setColorVariables(htmlEl, 'primary', {
        ...primaryHSL
    }, shades);
    this.setColorVariables(htmlEl, 'secondary', {
        ...secondaryHSL
    }, shades);
    this.setColorVariables(htmlEl, 'tertiary', {
        ...tertiaryHSL
    }, shades);
    this.setColorVariables(htmlEl, 'grey', {
        ...greyHSL
    }, shades);
    this.setColorVariables(htmlEl, 'danger', {
        ...dangerHSL
    }, shades);
    this.setColorVariables(htmlEl, 'success', {
        ...successHSL
    }, shades);
    this.setColorVariables(htmlEl, 'warning', {
        ...warningHSL
    }, shades);
    this.setColorVariables(htmlEl, 'info', {
        ...infoHSL
    }, shades);
    this.setColorVariables(htmlEl, 'male', {
        ...maleHSL
    }, shades);
    this.setColorVariables(htmlEl, 'female', {
        ...femaleHSL
    }, shades);
    this.setColorVariables(htmlEl, 'health', {
        ...healthHSL
    }, shades);
    this.setColorVariables(htmlEl, 'unhealth', {
        ...unhealthHSL
    }, shades);

    this.setShadowVariables(htmlEl, 'primary', primaryHSL);
}
 hslModify(
  hsl: HSLColor,
  options: HSLModifyOptions = {}
): HSLColor {
  const { h = {}, s = {}, l = {}, opacity = 1 } = options;

  const modifiedHsl: HSLColor = { ...hsl };

  if (h.fixed !== undefined) modifiedHsl.h = h.fixed;
  if (h.percent !== undefined) modifiedHsl.h *= (1 + h.percent / 100);
  if (h.adjust !== undefined) modifiedHsl.h += h.adjust;

  if (s.fixed !== undefined) modifiedHsl.s = s.fixed;
  if (s.percent !== undefined) modifiedHsl.s *= (1 + s.percent / 100);
  if (s.adjust !== undefined) modifiedHsl.s += s.adjust;

  if (l.fixed !== undefined) modifiedHsl.l = l.fixed;
  if (l.percent !== undefined) modifiedHsl.l *= (1 + l.percent / 100);
  if (l.adjust !== undefined) modifiedHsl.l += l.adjust;

  if (l.l !== undefined) modifiedHsl.l = l.l;
  if (h.l !== undefined) modifiedHsl.l = h.l;
  if (s.l !== undefined) modifiedHsl.l = s.l;
  
  if (l.h !== undefined) modifiedHsl.h = l.h;
  if (h.h !== undefined) modifiedHsl.h = h.h;
  if (s.h !== undefined) modifiedHsl.h = s.h;

  if (l.s !== undefined) modifiedHsl.s = l.s;
  if (h.s !== undefined) modifiedHsl.s = h.s;
  if (s.s !== undefined) modifiedHsl.s = s.s;

  modifiedHsl.opacity = opacity;

  return modifiedHsl;
}
 finalHSL(hsl) {
    const safeHSL = {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        opacity: hsl?.opacity ?? 1 // Use 1 if alpha is undefined or null
    };

    return `hsl(${safeHSL.h}deg ${safeHSL.s}% ${safeHSL.l}% / ${safeHSL.opacity})`;
}
 checkNetworkConnection = () => {
    this.network.onDisconnect().subscribe(() => {
      this.connectedToInternet = false;
      this.translate
        .get(["Please Connect to the Internet!", "Disconnected"])
        .subscribe(async (res) => {
          let alertMsg = await this.alertCtrl.create({
            header: this.translate.instant("no_internet"),
            message: this.translate.instant("please_connect_to_the_internet"),
            mode: "ios",
            buttons: [
              {
                text: this.translate.instant("ok"),
                handler: () => {
                  navigator["app"].exitApp();
                },
              },
            ],
          });
          alertMsg.present();
        });
    });
    this.network.onConnect().subscribe(() => {
      if (!this.connectedToInternet) {
        window.location.reload();
        const customer = this.authService.getAuthUser();
        if (customer) {
          // this.dataservice.getMySubscription(customer.id);
          // this.dataservice.getDaysData()
          // this.dataservice.getDayConfigData()
        }
        this.translate
          .get(["Network connected Reloading Data", "Connected"])
          .subscribe(async (res) => {
            let alertMsg = await this.alertCtrl.create({
              header: this.translate.instant("network_found"),
              message: this.translate.instant(
                "network_connected_reloading_data",
              ),
              mode: "ios",
              buttons: [{ text: this.translate.instant("ok") }],
            });
            alertMsg.present();
          });
      }
    });
  };
  showConfirm = async () => {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant("confirm"),
      message: this.translate.instant("are_you_sure_you_want_to_exit_the_app"),
      buttons: [
        {
          text: this.translate.instant("cancel"),
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: this.translate.instant("close_app"),
          handler: () => {
            navigator["app"].exitApp();
          },
        },
      ],
      //enterAnimation: customAlertEnter
    });
    await alert.present();
  };
	navigate = (data: any) => {
		this.navCtrl.navigateRoot([data], { animated: true });
	}
   initializeBackButton() {
    this.platform.ready().then(() => {
      if (this.backButtonSubscription) {
        this.backButtonSubscription.unsubscribe();
      }

      this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(10, async () => {
        try {
          // Close any open modal first
          const modal = await this.modalCtrl.getTop();
          if (modal) {
            modal.dismiss();
            return;
          }
        } catch (error) {
          console.log(error);
        }

        // Check if there's a page in the stack to go back
        if (this.router.url.startsWith('/tabs/')) {
          const currentTab = this.router.url.split('/')[2]; // Extract tab name
          if (this.router.url !== `/tabs/${currentTab}`) {
            this.router.navigateByUrl(`/tabs/${currentTab}`); // Reset tab to its main page
            return;
          }
        }

        if (this.isExitPage(this.router.url)) {
          if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
            navigator['app'].exitApp(); // Exit app on second press
          } else {
            const toast = await this.toastCtrl.create({
              message: this.translate.instant('press_back_again_to_exit_app'),
              duration: 2000,
              position: 'top',
              color: 'light',
            });
            toast.present();
            this.lastTimeBackPress = new Date().getTime();
          }
        } else {
          this.router.navigate(['/tabs/accounts']); // Default navigation to menu if stuck
        }
      });
    });
  }

  private isExitPage(url: string): boolean {
    return [
      '/',
      '/onboarding',
      '/tabs/menu',
      '/tabs/calendar',
      '/tabs/notifications',
      '/tabs/accounts',
      '/tabs/order',
    ].includes(url);
  }
}

// Color Functions

// l: {l: Math.min(Math.max(hsl.l * 1.15, 10),90)},

// l: {l: Math.min(Math.max(hsl.l + 20, 0),100)},

// l: {l: Math.min(Math.max((hsl.l + 10) * 0.8, 5),95)},

// l: {l: hsl.l > 60 ? Math.min(Math.max(hsl.l - 10, 20), 80) : Math.min(Math.max(hsl.l + 15, 10), 90)},


// h: {h: (hsl.h * 1.2) % 360}

// h: {h: (hsl.h + 40) % 360}

// h: {h: (hsl.h - 40 + 360) % 360}

// h: {h: ((hsl.h + 30) * 0.85) % 360}

// h: {h: hsl.h < 180 ? (hsl.h + 60) % 360 : (hsl.h - 60 + 360) % 360}

// h: {h: (hsl.h + 180) % 360}


// s: {s: Math.min(Math.max(hsl.s * 1.25, 10), 100)},

// s: {s: Math.min(Math.max(hsl.s - 20, 0), 100)}

// s: {s: Math.min(Math.max((hsl.s + 15) * 0.8, 5), 90)}

// s: {s: hsl.s > 60 ? Math.max(hsl.s - 25, 10) : Math.min(hsl.s + 30, 90)}